import { cloneTemplate } from '../../utils/queries';
import { CloneTemplateButton } from './CloneTemplateButton';
import { ArchiveTemplateButton } from './ArchiveTemplateButton';
import { useTemplatesListState } from '../../context/UseTemplatesListContext';
import { getOffsiteQueryKeysToInvalidate } from '../../utils/getQueryKeysToInvalidate';

export interface OffsiteOptionsProps {
  setShowModal(show: boolean): void;
}

export const OffsiteOptions = ({ setShowModal }: OffsiteOptionsProps) => {
  const { selectedTemplate } = useTemplatesListState();

  return (
    <>
      <CloneTemplateButton
        setShowModal={setShowModal}
        cloneFunction={cloneTemplate}
        getQueryKeysToInvalidate={() => getOffsiteQueryKeysToInvalidate(selectedTemplate)}
        selectedTemplate={selectedTemplate}
      />
      <ArchiveTemplateButton
        selectedTemplate={selectedTemplate}
        getQueryKeysToInvalidate={() => getOffsiteQueryKeysToInvalidate(selectedTemplate)}
      />
    </>
  );
};
